import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { TipiInterventoApi } from "../data/apis";
import { useMemo } from "react";

export function useTipoInterventoDataSource() {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new TipiInterventoApi(apiConfiguration);

        return new CustomStore({
            key: 'idTipoIntervento',
            loadMode: 'raw',
            load: (loadOptions) => {
                return api.getTipiIntervento();
            }
        })
    }, [])

    return dataSource;
}